import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.section-container {
    overflow: hidden;
}
.of-text {
    margin-left: 8px;
    font-size: 12px;
    white-space: nowrap;
    height: 22px;
    vertical-align: middle;
}
.left {
    font-size: 12px;
}
.right {
    font-size: 12px;
}
@media (min-width: 722px) {
    .left {
        width: calc(99.9% * 1/2 - (24px - 24px * 1/2));
    }
    .left:nth-child(1n) {
        float: left;
        margin-right: 24px;
        clear: none;
    }
    .left:last-child {
        margin-right: 0;
    }
    .left:nth-child(2n) {
        margin-right: 0;
        float: right;
    }
    .left:nth-child(2n + 1) {
        clear: both;
    }

    .right {
        width: calc(99.9% * 1/2 - (24px - 24px * 1/2));
    }

    .right:nth-child(1n) {
        float: left;
        margin-right: 24px;
        clear: none;
    }

    .right:last-child {
        margin-right: 0;
    }

    .right:nth-child(2n) {
        margin-right: 0;
        float: right;
    }

    .right:nth-child(2n + 1) {
        clear: both;
    }
}
@media (max-width: 720px) {
    .left {
        padding: 8px;
    }
    .right {
        padding: 8px;
    }
}
.overall-card-top {
    overflow: hidden;
}
.hollow-morningstar-footer {
    padding-bottom: calc(calc(24px / 2) / 2);
}
.m-header {
    text-align: left;
    margin-bottom: 8px;
}
.m-body {
    font-size: 18px;
    text-align: left;
    margin-bottom: 8px;
    position: relative;
    color: #3b3b3b;
}
.m-body > div {
    display: inline-block;
}
.see-ratings {
    color: #086ea1;
    text-align: left;
    font-size: 12px;
    text-decoration: none;
}
.overall-card-bottom {
  font-size: 12px;
  font-weight: 400;
  color: #111111;
    background-color: #fafafa;
    padding: calc(24px / 2);
    line-height: 1.33;
    text-align: left;
    margin-top: calc(24px / 2);
}
`;

export default styles;